define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/locale",
	"csi/reflection",
	"csi/table/Widget",
	"csi/xml",
	"../Locale",
	"./_Store",
	"./_TableMixin"
], function(declare, csi, _, locale, reflection, Table, xml, Locale, _Store, _TableMixin) {

	var _AttributeStore = declare(_Store, {
		typeSection: "Attr",

		// String: index for config resource
		keyConfig: "",

		// String: type containing attributes
		typeClass: null,

		getResourceKeys: function(/*Node*/node, /*String*/keyContainer) {
			// summary: return array of keys used to persist resource
			return [node.Type, this.typeSection, node.Id + keyContainer];
		},

		onPut: function(/*Node*/node, /*Object*/res) {
			// summary: add attribute-specific resources
			res[Locale.TOOLTIP] = this.lrConfig.getTypeAttributeResource(node.Type, node.Id, Locale.TOOLTIP) || "";
			res[Locale.ATTR_VALIDATION] = this.lrConfig.getTypeAttributeResource(node.Type, node.Id, Locale.ATTR_VALIDATION) || "";

			// make sure attribute defaults to site default name or id
			res.Base = res.Base || res.Site || node.Id;
		},

		_getAttributeResources: function(/*LocaleResolver*/lr, /*Class*/rc, /*Node[]*/data) {
			// summary: return resources for class
			if (!rc) return;

			var type = rc.getType();

			_.each(rc.getAttributes(true, true), function(rca) {
				// filter out CSS/Comment attributes
				var id = rca.getId();

				if (id.indexOf(".") >= 0) {
					return;
				}

				// filter out attributes that are not localized - except for Node Name
				if (!rca.isCustom && (id != xml.ATTR_NAME) && (lr.getTypeAttributeResource(type, id) == null)) {
					return;
				}

				var sourceType = rca.getOwner().getType();

				data.push(this._createNode(id, {
					LinkSourceType: ((sourceType != type) && this.lrBaseSite.getTypeResource(sourceType, locale.TYPE_NAME)) ? sourceType : null,
					SourceType: sourceType,
					Type: type
				}));
			}, this);
		},

		_getResource: function(/*Node*/node, /*LocaleResolver*/lr) {
			// summary: get resource for key from resolver
			return lr.getTypeAttribute(node.Type, node.Id);
		},

		_resolveData: function(/*Deferred*/dfd) {
			// summary: create items for store from all enabled, non-private classes with explicit Name
			var rc = reflection.getClass(this.typeClass);
			var data = [];

			this._getAttributeResources(this.lrBaseSite, rc, data);

			data = csi.sort(data, "Id");

			dfd.resolve(data);
		}
	});

	return declare([Table, _TableMixin], {
		storeClass: _AttributeStore,

		_createStore: function(/*Context*/ctx, /*Boolean*/bConfigurable) {
			// summary: create store for view
			var store = this.inherited(arguments);
			store.typeClass = this.getViewNode().$Name;
			return store;
		},

		_onAccessActionValidation: function(/*Context*/ctx, /*Action*/action) {
			// summary: only allow localizing validation if there is a validation expression
			var node = ctx.getNode();
			var rca = reflection.getClassAttribute(reflection.getClass(node.SourceType), node.Id);
			return rca && !!rca.getValidation();
		}
	});
});